import React from "react";
import "./Popup.scss";

export default function Popup({ popup, card, clickHandler }) {
  return (
    <>
      {popup && (
        <div className="popup">
          <div className="popup__card-container">
            <div className="popup__card">
              {card.hasLink ? (
                <a href={card.link}>
                  <h2 className="popup__title">{card.title}</h2>
                </a>
              ) : (
                <h2 className="popup__title">{card.title}</h2>
              )}
              <img src={card.img} alt={card.title} className="popup__img" />
              <p className="popup__description">{card.description}</p>
              <p className="popup__tools">Tools: {card.tools}</p>
              <button className="popup__btn" onClick={clickHandler}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
